import React from 'react'
import './articleItem.css'
import {getSubStringWithDot} from "../utils/commonFunc";

class ArticleItemAPP extends React.Component {
    constructor(props) {
        super(props)
    }

    handleClickItem = ()=> {
        this.props.clickItem(this.props.articleTitle,this.props.articleContent,this.props.articleId);
    };

    removeSufix = (fileName)=> {
        let fileNameList = fileName.split('.')
        if (fileNameList.length == 2 && fileNameList[1] === 'txt') {
            return fileNameList[0]
        }
        return fileName
    };

    render(){
        return(

            <div onClick={this.handleClickItem} className='article_item_div_style'>
                <h5 className='Article_title_style'>{getSubStringWithDot(28,this.removeSufix(this.props.articleTitle))}</h5>
                <br/>
                <h6 className='Article_content_style'>
                    {this.props.articleContent}
                </h6>
            </div>
        );
    }
}

export default ArticleItemAPP